import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { UpperCasePipe } from '@angular/common';
import { LangService, IDIOMAS } from '../../../core/services/lang.service';

@Component({
  selector: 'app-header',
  imports: [RouterLink, UpperCasePipe],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header {
  readonly idiomas = IDIOMAS;
  readonly lang = inject(LangService);
}
